import { createAnimData, createFiRow, IFrameAnimData } from '../engine/anims'
import { IMachine } from './machines'
import { anims } from '../engine/anims-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'

export interface IMachineAnims {
  reactorStop: IFrameAnimData
  reactorGo: IFrameAnimData
  o2Go: IFrameAnimData
  doorTopOpen: IFrameAnimData
  doorBottomOpen: IFrameAnimData
  doorTopClose: IFrameAnimData
  doorBottomClose: IFrameAnimData
  doorAirlockTopOpen: IFrameAnimData
  doorAirlockBottomOpen: IFrameAnimData
  doorAirlockTopClose: IFrameAnimData
  doorAirlockBottomClose: IFrameAnimData
}

const createMachineAnims = () => {
  let ma: IMachineAnims = {
    reactorStop: createAnimData(createFiRow(5, 13, 3, 1)),
    reactorGo: createAnimData(createFiRow(5, 13, 2, 2)),
    o2Go: createAnimData(createFiRow(5, 16, 5, 2)),

    doorTopOpen: createAnimData(createFiRow(8, 14, 2, 7)),
    doorBottomOpen: createAnimData(createFiRow(8, 15, 2, 7)),
    doorTopClose: createAnimData(createFiRow(8, 14, 2, 7).reverse()),
    doorBottomClose: createAnimData(createFiRow(8, 15, 2, 7).reverse()),

    doorAirlockTopOpen: createAnimData(createFiRow(8, 12, 2, 7)),
    doorAirlockBottomOpen: createAnimData(createFiRow(8, 13, 2, 7)),
    doorAirlockTopClose: createAnimData(createFiRow(8, 12, 2, 7).reverse()),
    doorAirlockBottomClose: createAnimData(createFiRow(8, 13, 2, 7).reverse()),
  }
  let delay = 1 / 15
  ma.doorTopClose.delay = delay
  ma.doorTopClose.loop = false
  ma.doorBottomClose.delay = delay
  ma.doorBottomClose.loop = false
  ma.doorTopOpen.delay = delay
  ma.doorTopOpen.loop = false
  ma.doorBottomOpen.delay = delay
  ma.doorBottomOpen.loop = false

  // let delay = 1 / 15
  ma.doorAirlockTopClose.delay = delay
  ma.doorAirlockTopClose.loop = false
  ma.doorAirlockBottomClose.delay = delay
  ma.doorAirlockBottomClose.loop = false
  ma.doorAirlockTopOpen.delay = delay
  ma.doorAirlockTopOpen.loop = false
  ma.doorAirlockBottomOpen.delay = delay
  ma.doorAirlockBottomOpen.loop = false

  return ma
}
export const all: IMachineAnims = createMachineAnims()

export function playAnim(obj: IMachine, ad: IFrameAnimData, force?: boolean) {
  anims.play(obj.anim, ad, force)
  updateAnimFrame(obj)
}
export function updateAnim(obj: IMachine) {
  anims.update(obj.anim, () => {
    updateAnimFrame(obj)
  })
}
function updateAnimFrame(obj: IMachine) {
  spriteMap.setFrame(obj.image, obj.anim.data.frames[obj.anim.frameIdx].fi)
}
